import { getRequestContext } from '../ssr-bridge/index.js';
import { getGlobalThis, isServer } from '../utils/index.js';
export function getQueryParams() {
    if (isServer()) {
        return getRequestContext()?.params || {};
    }
    const win = getGlobalThis();
    const queryString = win.location ? win.location.search : '';
    const searchParams = new URLSearchParams(queryString);
    const queryParams = {};
    for (const [key, val] of searchParams) {
        queryParams[key] = val;
    }
    return queryParams;
}
//# sourceMappingURL=browser.js.map